import {HStack, Icon, Show, Spinner, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {smtpCredentialsTestStatus} from '../constants/smtpCredentialsTestStatus';
import type {SmtpTestChecklistRow} from '../types/SmtpTestChecklistRow';
import {getSmtpTestStatusPresentation} from '../utils/getSmtpTestStatusPresentation';
import {getSmtpTestTypeHint} from '../utils/getSmtpTestTypeHint';
import {getSmtpTestTypeLabel} from '../utils/getSmtpTestTypeLabel';

interface SmtpCredentialsTestChecklistItemProps extends TestIdProps {
  row: SmtpTestChecklistRow;
}

export function SmtpCredentialsTestChecklistItem(props: SmtpCredentialsTestChecklistItemProps) {
  if (props.row.isActive) {
    return (
      <HStack spacing={2} align="flex-start" data-testid={props['data-testid']}>
        <Spinner size="small" data-testid={props['data-testid']} />
        <Text size="small">{getSmtpTestTypeLabel(props.row.type)}</Text>
      </HStack>
    );
  }
  const presentation = getSmtpTestStatusPresentation(props.row.status);
  const hint = getSmtpTestTypeHint(props.row.type, props.row.status, props.row.reason);

  return (
    <HStack spacing={2} align="flex-start" data-testid={props['data-testid']}>
      <Icon
        value={presentation.icon}
        size={4}
        color={presentation.color}
        data-testid={props['data-testid']}
      />
      <VStack spacing={1}>
        <HStack spacing={2}>
          <Text size="small" color={presentation.textColor}>
            {getSmtpTestTypeLabel(props.row.type)}
          </Text>
          <Show when={props.row.status === smtpCredentialsTestStatus.skip}>
            <Text size="small" color="secondary">
              {i18n.t('entity.emailService.labels.testStatusSkipped')}
            </Text>
          </Show>
        </HStack>
        <Show when={hint}>
          {(value) => (
            <Text size="small" color={presentation.textColor}>
              {value}
            </Text>
          )}
        </Show>
      </VStack>
    </HStack>
  );
}
